export class ScheduleDStepOneRegExPattern {
    public static readonly TowerRegistrationNumber = '^(\\d{7}|[Aa]\\d{7})$';

    /*
     * Used for the regex directive, cannot pass in length validation, only characters.
     * This field only allows digits and the letter A.
     */
    public static readonly TowerRegistrationNumberAllowedCharacters =
        '^[Aa\\d]+$';
}
